import PropTypes from 'prop-types';
import React from 'react';
import Styles from './DomElements.scss';

const Label = (props) => {
    const { text } = props;

    return <span className={Styles.domElLabel}>{text}</span>;
};

Label.propTypes = {
    text: PropTypes.string,
};
export default Label;
